import { useRef, useEffect } from "react";
// import { useSelector } from "react-redux";
import { useState } from "react";
import { Col, Container } from "react-bootstrap";
import AssignmentsCard from "./AdminCards/AssignmentsCard";
import PollCard from "./AdminCards/PollsCard";
import TimerCard from "./AdminCards/TimerCard";
import EventsCard from "./AdminCards/EventsCard";
import RolesCard from "./AdminCards/RolesCard";

export default function Sidebar({ getMeeting, getRoleAssignment, assignments, agenda }) {

  // const { user: authUser } = useSelector((state) => state.auth);
  const editorRef = useRef(null);

  const [isEditorVisible, setIsEditorVisible] = useState(false);

  const toggleEditor = () => setIsEditorVisible((prev) => !prev);

  const handleClickOutside = (event) => {
    if (editorRef.current && !editorRef.current.contains(event.target)) {
      setIsEditorVisible(false);
    }
  };

  useEffect(() => {
    if (isEditorVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    console.log("Editor visibility changed:", isEditorVisible);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isEditorVisible]);

  return (
    <>
      {/* {authUser?.user.acl === "Officer" && ( */}
      <button
        onClick={toggleEditor}
        style={{
          position: "fixed",
          top: "100px",
          right: isEditorVisible
            ? window.innerWidth >= 992
              ? "calc(33.333% - 8px)"
              : "calc(83.333% - 8px)"
            : "-8px",
          zIndex: 1050,
          backgroundColor: "black",
          color: "white",
          border: "none",
          padding: "10px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        className="toggle-editor-btn"
      >
        {isEditorVisible ? (
          <i className="bi bi-chevron-right"></i>
        ) : (
          <i className="bi bi-chevron-left"></i>
        )}
      </button>
      {/* )} */}
      {isEditorVisible && (
        <Col
          id="editor"
          xs={10}
          lg={4}
          ref={editorRef}
          className="editor-overlay"
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            overflow: "auto",
            zIndex: 1040,
            transition: "width 0.3s ease-in-out",
          }}
        >
          <h4 className="p-3">Meeting Tools</h4>
          <Container>
            <AssignmentsCard getMeeting={getMeeting} getRoleAssignment={getRoleAssignment} assignments={assignments} />
            <PollCard agenda={agenda} />
            <TimerCard agenda={agenda} />
            <EventsCard />
            <RolesCard />
          </Container>
        </Col>
      )}
    </>
  )
}